var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("嵌入本地 Vue 页面")]),_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"800px","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }